import React from 'react';
import { LoginForm } from '../../components/forms';
import { useNavigate } from 'react-router-dom';
import { TabGroup } from '../../components/common';
import { routes } from '../../lib/routes';

const LoginPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className='h-full flex flex-col lg:justify-center w-full max-w-[27.5rem] mx-auto lg:py-12 py-8'>
      <h2 className='h3 !font-medium mb-1 text-heading-500 lg:text-left text-center'>Login</h2>
      <p className='text-sm mb-6 lg:text-left text-center'>
        Please sign in to discover the best options that meet your needs.
      </p>

      <TabGroup
        tabs={[
          { label: 'Login', value: 'login' },
          { label: 'Signup', value: 'signup' },
        ]}
        activeTab='login'
        onChange={tab => navigate(routes[tab as keyof typeof routes])}
        tabSize='md'
      />

      <LoginForm />
    </div>
  );
};

export default LoginPage;
